"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DialogBase {
    constructor(dialogManager) {
        this.dialogManager = dialogManager;
    }
    getCloseButton() {
        return this.closeButton;
    }
    getButtons() {
        return this.buttons;
    }
    show(options) {
        this.closeButton = options.closeButton;
        this.buttons = options.buttons;
        this.dialogManager.show(this, options);
    }
    hide() {
        this.dialogManager.hide();
    }
}
exports.default = DialogBase;
//# sourceMappingURL=DialogBase.js.map